module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "title fg-darkCyan"
  }, [_vm._v("Flex grid 栅格布局")]), _vm._v(" "), _c('section', {
    staticClass: "box flex-grid demo-grid"
  }, [_c('p', {
    staticClass: "fg-gray no-margin"
  }, [_vm._v("默认cell大小")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("<article class=\"flex-grid\">\n    <!--row相当于12个普通cell的宽度，也就是100%-->\n    <div class=\"row\">\n        <div class=\"cell bg-teal\">cell</div>\n    </div>\n</article>\n")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "fg-gray no-margin"
  }, [_vm._v("多个cell")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "fg-gray no-margin"
  }, [_vm._v("占5列的cell")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_vm._m(3)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
    staticClass: "fg-darkCyan"
  }, [_vm._v("Justify 对齐方式")]), _vm._v(" "), _c('p', {
    staticClass: "fg-gray no-margin"
  }, [_vm._v("justify-start 左对齐")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "fg-gray no-margin"
  }, [_vm._v("justify-end 右对齐")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "fg-gray no-margin"
  }, [_vm._v("justify-center 居中")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "fg-gray no-margin"
  }, [_vm._v("space-around 平均分布(左右间隔相等)")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "fg-gray no-margin"
  }, [_vm._v("space-between 两端对齐")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('pre', {
    directives: [{
      name: "prettify",
      rawName: "v-prettify"
    }],
    staticClass: "prettyprint linenums"
  }, [_c('code', {
    pre: true
  }, [_vm._v("\n<!--justify-start 左对齐-->\n<div class=\"row\"></div>\n<!--justify-end 右对齐-->\n<div class=\"row flex-just-end\"></div>\n<!--justify-center 居中-->\n<div class=\"row flex-just-center\"></div>\n<!--space-around 平均分布(左右间隔相等)-->\n<div class=\"row flex-just-sa\"></div>\n<!--space-between 两端对齐-->\n<div class=\"row flex-just-sb\"></div>\n")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "cell bg-teal"
  }, [_vm._v("cell")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "cell bg-teal"
  }, [_vm._v("cell")]), _vm._v(" "), _c('div', {
    staticClass: "cell bg-teal"
  }, [_vm._v("cell")]), _vm._v(" "), _c('div', {
    staticClass: "cell bg-teal"
  }, [_vm._v("cell")]), _vm._v(" "), _c('div', {
    staticClass: "cell bg-teal"
  }, [_vm._v("cell")]), _vm._v(" "), _c('div', {
    staticClass: "cell bg-teal"
  }, [_vm._v("cell")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "cell colspan5 bg-amber"
  }, [_vm._v("cell colspan5")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('code', {
    pre: true
  }, [_vm._v("\n<article class=\"flex-grid\">\n    <div class=\"row\">\n        <div class=\"cell bg-teal\">cell</div>\n        <div class=\"cell bg-teal\">cell</div>\n        <div class=\"cell bg-teal\">cell</div>\n        <div class=\"cell bg-teal\">cell</div>\n        <div class=\"cell bg-teal\">cell</div>\n    </div>\n\n    <div class=\"row\">\n        <!--"), _c('span', {
    attrs: {
      "class": "tag alert fg-white"
    }
  }, [_vm._v("colspan*")]), _vm._v("表示占几列-->\n        <div class=\"cell colspan5 bg-amber\">cell colspan5</div>\n    </div>\n</article>\n")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('section', {
    staticClass: "cell bg-lightBlue"
  }, [_vm._v("cell")]), _vm._v(" "), _c('section', {
    staticClass: "cell bg-lightBlue"
  }, [_vm._v("cell")]), _vm._v(" "), _c('section', {
    staticClass: "cell bg-lightBlue"
  }, [_vm._v("cell")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row flex-just-end"
  }, [_c('section', {
    staticClass: "cell bg-lightBlue"
  }, [_vm._v("cell")]), _vm._v(" "), _c('section', {
    staticClass: "cell bg-lightBlue"
  }, [_vm._v("cell")]), _vm._v(" "), _c('section', {
    staticClass: "cell bg-lightBlue"
  }, [_vm._v("cell")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row flex-just-center"
  }, [_c('section', {
    staticClass: "cell bg-lightBlue"
  }, [_vm._v("cell")]), _vm._v(" "), _c('section', {
    staticClass: "cell bg-lightBlue"
  }, [_vm._v("cell")]), _vm._v(" "), _c('section', {
    staticClass: "cell bg-lightBlue"
  }, [_vm._v("cell")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row flex-just-sa"
  }, [_c('section', {
    staticClass: "cell bg-lightBlue"
  }, [_vm._v("cell")]), _vm._v(" "), _c('section', {
    staticClass: "cell bg-lightBlue"
  }, [_vm._v("cell")]), _vm._v(" "), _c('section', {
    staticClass: "cell bg-lightBlue"
  }, [_vm._v("cell")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row flex-just-sb"
  }, [_c('section', {
    staticClass: "cell bg-lightBlue"
  }, [_vm._v("cell")]), _vm._v(" "), _c('section', {
    staticClass: "cell bg-lightBlue"
  }, [_vm._v("cell")]), _vm._v(" "), _c('section', {
    staticClass: "cell bg-lightBlue"
  }, [_vm._v("cell")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-780171e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/grid/grid.vue
// module id = 404
// module chunks = 1